<template>
	<van-popup
		v-model="show"
		position="bottom"
		:style="{ height: '80%' }"
		round
		closeable
		@close="handleClose"
	>
		<div class="ocr-popup">
			<div class="ocr-header">
				<h3>AI-OCR识别</h3>
				<p>请选择照片或者拍照上传</p>
			</div>

			<div class="ocr-content">
				<div class="upload-section">
					<base-multiple-upload
						v-model="fileList"
						:limit="5"
						accept="image/jpeg,image/jpg,image/png,image/bmp"
						:before-read="beforeRead"
						:after-read="afterRead"
						@delete="handleDelete"
					>
						<div class="upload-btn">
							<van-icon name="plus" size="24" />
							<span>添加图片</span>
						</div>
					</base-multiple-upload>
					<p class="upload-tip">
						支持jpg、png、bmp格式，最多上传5张图片
					</p>
				</div>
			</div>

			<div class="ocr-footer">
				<van-button
					type="primary"
					block
					:disabled="fileList.length === 0 || loading"
					:loading="loading"
					@click="startOcrRecognition"
				>
					{{ loading ? "识别中..." : "开始OCR识别" }}
				</van-button>
			</div>
		</div>
	</van-popup>
</template>

<script>
import BaseMultipleUpload from "@/components/base-multiple-upload/index.vue";

export default {
	name: "FormOcrPopup",
	components: {
		BaseMultipleUpload,
	},
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		ocrKeywords: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			fileList: [],
			loading: false,
			showPreview: false,
			previewImages: [],
			previewIndex: 0,
		};
	},
	computed: {
		show: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
	},
	methods: {
		handleClose() {
			this.show = false;
			this.$emit("close");
		},
		beforeRead(file) {
			if (Array.isArray(file)) {
				let isValid = true;
				for (let i = 0; i < file.length; i++) {
					const f = file[i];
					const isImage = f.type.includes("image/");
					if (!isImage) {
						this.$toast("请上传图片文件");
						isValid = false;
						break;
					}

					const isLt5M = f.size / 1024 / 1024 < 5;
					if (!isLt5M) {
						this.$toast("图片大小不能超过5MB");
						isValid = false;
						break;
					}

					if (this.fileList.length + file.length > 5) {
						this.$toast("最多只能上传5张图片");
						isValid = false;
						break;
					}
				}
				return isValid;
			} else {
				const isImage = file.type.includes("image/");
				if (!isImage) {
					this.$toast("请上传图片文件");
					return false;
				}

				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isLt5M) {
					this.$toast("图片大小不能超过5MB");
					return false;
				}

				if (this.fileList.length >= 5) {
					this.$toast("最多只能上传5张图片");
					return false;
				}

				return true;
			}
		},
		afterRead(file) {
			if (Array.isArray(file)) {
				file.forEach((f) => {
					f.status = "done";
					f.url = f.content;
				});
			} else {
				file.status = "done";
				file.url = file.content;
			}
		},
		handleDelete(file, detail) {
			this.fileList.splice(detail.index, 1);
		},
		deleteImage(index) {
			this.fileList.splice(index, 1);
		},
		previewImage(file) {
			this.previewImages = this.fileList.map((item) => item.url);
			this.previewIndex = this.fileList.indexOf(file);
			this.showPreview = true;
		},
		async startOcrRecognition() {
			if (this.fileList.length === 0) {
				this.$toast("请先上传图片");
				return;
			}

			try {
				this.loading = true;
				const imageUrls = this.fileList.map((file) => file.url);
				const testParams = {
					fields: "性别,年龄,24小时尿蛋白定量,随机尿总蛋白/肌酐比值,UPCR,尿总蛋白/肌酐,尿总蛋白/尿肌酐,随机尿白蛋白/肌酐比值,UACR,尿白蛋白/肌酐,尿白蛋白肌酐,血肌酐,Scr,肌酐,胱抑素C,Cys C,eGFR,血钾,钾,血磷,磷,血钙,钙,血红蛋白,Hb,HGB",
					remark: "返回时去掉计量单位",
					url: [
						"https://common-test-bucket-1323288472.cos.ap-beijing.myqcloud.com/marketing/2025-12-29/img_v3_02te_09a96986-0e73-473b-ad78-cdb61cbd935g-1766988544890.jpg",
						"https://common-test-bucket-1323288472.cos.ap-beijing.myqcloud.com/marketing/2026-01-07/img_v3_02te_4cfd0b3c-b966-4cb9-930a-f27f879a0d9g-1767778500342.png",
						"https://common-test-bucket-1323288472.cos.ap-beijing.myqcloud.com/marketing/2026-01-07/img_v3_02te_aa6742da-40d3-4fb9-8797-0d108de91e2g-1767778537295.png",
					],
				};
				const res = await this.$api.surveys.submitOCR(
					// testParams
					{
						url: imageUrls,
						fields: this.ocrKeywords.join(","),
					}
				);

				if (!res.code) {
					let parsedData;
					try {
						parsedData = JSON.parse(res.data);
					} catch (e) {
						console.error("解析OCR数据失败:", e);
						this.$toast("数据解析失败，请重试");
						return;
					}
					this.$emit("ocr-success", parsedData, imageUrls);
				} else {
					this.$toast(res.msg || "识别失败，请重试");
				}
			} catch (error) {
				console.error("OCR识别失败:", error);
				this.$toast("识别失败，请重试");
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style lang="less" scoped>
.ocr-popup {
	display: flex;
	flex-direction: column;
	height: 100%;
	padding: 16px;
	box-sizing: border-box;

	.ocr-header {
		text-align: center;
		margin-bottom: 20px;

		h3 {
			margin: 0 0 8px;
			font-size: 18px;
			font-weight: 600;
		}

		p {
			margin: 0;
			font-size: 14px;
			color: #999;
		}
	}

	.ocr-content {
		flex: 1;
		overflow-y: auto;

		.upload-section {
			margin-bottom: 20px;

			.upload-btn {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				height: 100px;
				border: 1px dashed #ddd;
				border-radius: 4px;
				background-color: #f9f9f9;
				color: #666;

				span {
					margin-top: 8px;
					font-size: 14px;
				}
			}

			.upload-tip {
				margin-top: 8px;
				font-size: 12px;
				color: #999;
				text-align: center;
			}
		}

		.preview-section {
			.preview-list {
				display: flex;
				flex-wrap: wrap;
				gap: 10px;

				.preview-item {
					position: relative;
					width: 80px;
					height: 80px;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
						border-radius: 4px;
					}

					.delete-btn {
						position: absolute;
						top: -5px;
						right: -5px;
						width: 20px;
						height: 20px;
						background-color: #f44;
						color: #fff;
						border-radius: 50%;
						display: flex;
						align-items: center;
						justify-content: center;
						font-size: 12px;
					}
				}
			}
		}
	}

	.ocr-footer {
		padding-top: 16px;
	}
}
::v-deep(.van-uploader__wrapper) {
	margin: 10px;
}
</style>
